import { useState } from "react";
import { Fab, Tooltip, useTheme } from "@mui/material";
import { SmartToy } from "@mui/icons-material";
import { PricingAgentChat } from "./PricingAgentChat";

export const PricingAgentButton = ({ filters }) => {
  const [isOpen, setIsOpen] = useState(false);
  // Keep chat mounted after first open so history survives minimize/close.
  const [hasOpened, setHasOpened] = useState(false);
  const theme = useTheme();

  const openChat = () => {
    setHasOpened(true);
    setIsOpen(true);
  };

  return (
    <>
      {!isOpen && (
        <Tooltip title="Chat with Pricing Coach" placement="left">
          <Fab
            onClick={openChat}
            sx={{
              position: "fixed",
              bottom: 30,
              right: 30,
              width: 64,
              height: 64,
              bgcolor: theme.palette.primary.main,
              color: "white",
              zIndex: 1300,
              "&:hover": {
                bgcolor: theme.palette.primary.main,
                transform: "scale(1.1)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          >
            <SmartToy sx={{ fontSize: 30 }} />
          </Fab>
        </Tooltip>
      )}

      {hasOpened && (
        <div style={{ display: isOpen ? "contents" : "none" }}>
          <PricingAgentChat
            filters={filters}
            onClose={() => setIsOpen(false)}
          />
        </div>
      )}
    </>
  );
};
